<div id="theme-root" class="theme">
  <router-outlet />
</div>
